const initState = {
  payment: [],
  page: 1,
  limit: 10,
  count: 0,
};

const PaymentReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_PAYMENT":
      return {
        ...state,
        payment: action.payload.data,
        page: action.payload.page,
        limit: action.payload.limit,
        count: action.payload.count,
      };
    case "RESET_PAYMENT_STATE":
      return {
        ...state,
        ...initState,
      };
    default:
      return { ...state };
  }
};

export default PaymentReducer;
